import React from 'react';
import FormWrapper from '../../../../../../Components/Form/FormWrapper';
import InputWrapper from '../../../../../../Components/Form/components/InputWrapper/InputWrapper';
import InputField from '../../../../../../Components/Form/components/InputField';
import SubmitButton from '../../../../../../Components/Button/SubmitButton';
import { BankAccount } from './BankAccountSetup';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';

interface Props {
	defaultValues: BankAccount;
	onSuccess: (values: BankAccount) => void;
}

const BankAccountSetupMexicoForm: React.FC<Props> = ({
	defaultValues,
	onSuccess,
}) => {
	const validationSchema = yup.object({
		number: yup.string().required(),
		name: yup.string(),
		type: yup.string(),
		clabe: yup.string().required(),
	});

	const formMethods = useForm({
		resolver: yupResolver(validationSchema),
		defaultValues,
	});

	const handleOnSubmit = (values: any) => {
		onSuccess(values);
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<div className='mb-3'>
				<InputWrapper>
					<InputField
						name='number'
						label='registration.account.number'
						isRequired
					/>
				</InputWrapper>
				<InputWrapper>
					<InputField name='name' label='registration.account.name' />
				</InputWrapper>
				<InputWrapper>
					<InputField name='type' label='registration.account.type' />
				</InputWrapper>
				<InputWrapper>
					<InputField
						name='clabe'
						label='registration.account.clabe'
						isRequired
					/>
				</InputWrapper>
			</div>
			<SubmitButton onSubmit={handleOnSubmit} title='base.shared.save' />
		</FormWrapper>
	);
};

export default BankAccountSetupMexicoForm;
